





































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({})
export default class DialogVerifikasiSampai extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ default: null }) readonly transfer!: any;

  password = "";
  showEye = false;

  get msg(): string {
    return appModule.msgTtd;
  }

  get namaPasien(): string {
    return this.transfer?.pasien?.nama || this.transfer?.nama_pasien || "-";
  }

  get noRm(): string {
    return this.transfer?.pasien?.rm || "";
  }

  get namaUnitAsal(): string {
    return this.transfer?.from_unit?.name || this.transfer?.from_unit_id || "-";
  }

  get namaUnitTujuan(): string {
    return this.transfer?.to_unit?.name || this.transfer?.to_unit_id || "-";
  }

  get namaPengirim(): string {
    return this.transfer?.from_user?.nama || "-";
  }

  get unitLoginNama(): string {
    return userModule.user?.unit || userModule.user?.unit_id || "-";
  }

  get isPengirimLogin(): boolean {
    if (typeof this.transfer?.is_pengirim === "boolean") {
      return this.transfer.is_pengirim;
    }
    return (
      this.transfer?.from_user_id != null &&
      String(this.transfer.from_user_id) === String(userModule.user?.id)
    );
  }

  get diUnitTujuan(): boolean {
    return (
      this.transfer?.to_unit_id != null &&
      String(this.transfer.to_unit_id) === String(userModule.user?.unit_id)
    );
  }

  get perluPin(): boolean {
    return !this.isPengirimLogin;
  }

  @Watch("value")
  onValueChanged(val: boolean) {
    appModule.addMsgTtd("");
    if (val) {
      if (this.perluPin) {
        setTimeout(() => {
          const field = this.$refs.pin as any;
          if (field && typeof field.focus === "function") field.focus();
        }, 250);
      }
    } else {
      this.password = "";
      this.showEye = false;
    }
  }

  @Watch("msg")
  onMsgChanged(val: string) {
    if (val && this.value) {
      this.password = "";
    }
  }

  konfirmasi() {
    if (this.loading || !this.diUnitTujuan) return;
    if (this.perluPin && !this.password) return;
    appModule.addMsgTtd("");
    this.$emit("confirm", this.perluPin ? this.password : "");
  }

  tutup() {
    this.$emit("input", false);
  }
}
